export const defaultState = () => {
  return {
    currentLayout: '',
    articleSearch: {
      searchTitle: '',
      searchDesc: '',
      limit: 10,
      searchResult: {
        articles: [],
        total: 0,
      },
    },
    categorySearch: {
      playList: [],
      video: {
        id: '',
        key: '',
      },
    },
    gethelp: new Array({
      key: String,
      value: new Array({
        id: String,
        order: Number,
        relatedLinks: new Array({
          order: Number,
          title: String,
          url: String,
        }),
        title: String,
        url: String,
        video: String,
      }),
    }),
    isApiCalling: false,
    isShowModal: false,
    isShowIcon: false,
    momentOpen: Date,
    momentClose: Date,
  };
};

const state = defaultState();

export default state;
